import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { withUser } from '../../utility/withUser';
import { connect } from 'react-redux';
import WaitForState from '../WaitForState';
import { saveProfile, changePassword, getUser, getRoles, hasOneOfPermissions } from '../../utility/account';
import { addMessage } from '../../actions/messages';
import { setToken } from '../../actions/token';

/**
 * Component for showing users list.
 *
 * @extends React.Component
 */
class Users extends Component {
  /** @inheritdoc */
  constructor(props) {
    super(props);
    var user = props.userId ? null : JSON.parse(JSON.stringify(props.user));
    this.state = {
      password: "",
      passwordRepeat: "",
      originalUser: JSON.parse(JSON.stringify(user)),
      userCopy: user,
      doneWorking: true,
      currentUser: props.userId ? false : true,
      allRoles: null,
      assignAllowed: [],
    }
  }

  /**
   * Fetch a user from the supplied id.
   */
  fetchUser = () => {
    getUser(this.props.userId, this.props.token, this.props.history, (response) => {
      if (response.status !== 200) {
        this.props.dispatch(addMessage('Fejl under hentning af bruger. Prøv venligst igen senere.', 'danger'));
      }

      response.json().then((data) => {
        this.setState({userCopy: data, originalUser: JSON.parse(JSON.stringify(data))});
      });
    });
  }

  /**
   * Fetch whether or not user has permission to assign specific roles.
   */
  fetchAssignAllowedPermissions = () => {
    var roles = [
      'admin',
      'supervisor',
      'advisor',
    ];
    var permissionsToCheck = [];
    roles.forEach((role) => {
      permissionsToCheck.push('assign ' + role + ' role');
    });
    permissionsToCheck.push('assign any role');

    hasOneOfPermissions(this.props.user.id, permissionsToCheck, this.props.token, this.props.history, (oneAllowed, allowed, response) => {
      if (response.status === 200) {
        var assignAllowed = [];
        roles.forEach((role) => {
          assignAllowed[role] = allowed['assign any role'];

          if (!assignAllowed[role]) {
            assignAllowed[role] = allowed['assign ' + role + ' role'];
          }
        });

        this.setState({assignAllowed: assignAllowed});
      }
    });
  }

  /**
   * Handle when the password field changes.
   */
  handlePasswordChange = (e) => {
    this.setState({password: e.target.value});
  }

  /**
   * Handle when the password repeat field changes.
   */
  handlePasswordRepeatChange = (e) => {
    this.setState({passwordRepeat: e.target.value});
  }

  /**
   * Handle when a user clicks the change password button.
   */
  handleClickChangePassword = () => {
    this.setState({doneWorking: false});
    changePassword(this.state.userCopy.id, this.state.password, this.props.token, this.props.history, (response) => {
      if (response.status !== 200) {
        this.props.dispatch(addMessage('Fejl under ændring af adgangskode. Prøv venligst igen senere.', 'danger'));
      }
      this.setState({doneWorking: true, password: "", passwordRepeat: ""});
    });
  }

  /**
   * Handle when a field changes.
   */
  handleFieldChange = (field, e) => {
    var user = this.state.userCopy;
    user[field] = e.target.value;
    this.setState({userCopy: user});

    // We don't want to trigger a request every time the user touches his
    // keyboard. Only trigger when he has not done so in half a second.
    if (this.saveTimeout !== undefined) {
      window.clearTimeout(this.saveTimeout);
    }
    this.saveTimeout = window.setTimeout(() => {
      this.setState({doneWorking: false});
      var fieldNames = ['name', 'email', 'phone', 'active'];
      var fields = {};
      var ctx = this;
      fieldNames.forEach((fieldName) => {
        if (ctx.state.originalUser[fieldName] !== this.state.userCopy[fieldName]) {
          fields[fieldName] = this.state.userCopy[fieldName];
        }
      });
      saveProfile(this.state.userCopy.id, fields, this.props.token, this.props.history, (response) => {
        if (response.status !== 200) {
          this.props.dispatch(addMessage('Fejl under gemning af bruger. Prøv venligst igen senere.', 'danger'));
          this.setState({doneWorking: true});
          return;
        }
        if (this.state.currentUser) {
          this.props.dispatch(setToken(this.props.token, this.state.userCopy));
        }
        this.setState({doneWorking: true});
      });
    }, 500);
  }

  /**
   * Get role as readable string
   */
  getReadableRole = (role) => {
    var roleMap = {
      admin: 'Administrator',
      supervisor: 'Vejleder',
      advisor: 'Frivillig',
    };

    if (roleMap[role]) {
      return roleMap[role];
    }

    return role;
  }

  /**
   * Whether or not user has role.
   */
  hasRole = (role) => {
    var hasRole = false;
    this.state.userCopy.roles.forEach((userRole) => {
      if (userRole === role.name) {
        hasRole = true;
      }
    });

    return hasRole;
  }

  /**
   * Fetch roles.
   */
  fetchRoles = () => {
    getRoles(this.props.token, this.props.history, (response) => {
      if (response.status !== 200) {
        this.props.dispatch(addMessage('Fejl under hentning af roller. Prøv venligst igen senere.', 'danger'));
        return;
      }

      response.json().then((data) => {
        var items = {};
        Object.values(data).forEach((item) => {
          items[item.id] = item;
        });
        this.setState({allRoles: items});
      });
    });
  }

  /**
   * Handle when checkbox for a role changes.
   */
  handleRoleChange = (roleId, e) => {
    var selectedRole = this.state.allRoles[roleId].name;
    if (!this.state.assignAllowed[selectedRole]) {
      return;
    }
    var newRoles = [];
    if (e.target.checked) {
      var found = false;
      newRoles = this.state.userCopy.roles;
      newRoles.forEach((role) => {
        if (role === selectedRole) {
          found = true;
        }
      });

      if (!found) {
        newRoles.push(selectedRole);
      }
    } else {
      this.state.userCopy.roles.forEach((role) => {
        if (role !== selectedRole) {
          newRoles.push(role);
        }
      });
    }

    var newUser = this.state.userCopy;
    newUser.roles = newRoles;
    this.setState({userCopy: newUser, doneWorking: false});
    saveProfile(this.state.userCopy.id, {roles: newRoles}, this.props.token, this.props.history, (response) => {
      if (response.status !== 200) {
        this.props.dispatch(addMessage('Fejl under gemning af bruger. Prøv venligst igen senere.', 'danger'));
        this.setState({doneWorking: true});
        return;
      }
      if (this.state.currentUser) {
        this.props.dispatch(setToken(this.props.token, this.state.userCopy));
      }
      this.setState({doneWorking: true});
    });
  }

  /** @inheritdoc */
  componentDidMount = () => {
    if (this.props.userId) {
      this.fetchUser();
    }
    this.fetchRoles();
    this.fetchAssignAllowedPermissions();
  }

  /** @inheritdoc */
  componentWillReceiveProps = () => {
    // When component receives props (eg. user), permissions might change.
    this.fetchAssignAllowedPermissions();
  }

  /** @inheritdoc */
  render() {
    return (
      <div className="tab-pane fade show active" id="profile" role="tabpanel" aria-labelledby="profile">
        <div className="widget">
          <WaitForState state={this.state} keys={['doneWorking']} />
          {this.state.currentUser && <h3 className="section-heading">Din profil</h3>}
          {!this.state.currentUser && <h3 className="section-heading">Rediger bruger</h3>}
          <WaitForState state={this.state} keys={['userCopy']}>
            {this.state.userCopy && (
              <div>
                <div className="form-group">
                  <label htmlFor="name">Navn</label>
                  <input type="text" className="form-control" id="name" value={this.state.userCopy.name} onChange={(e) => {this.handleFieldChange('name', e);}} />
                </div>
                <div className="form-group">
                  <label htmlFor="email">E-mail</label>
                  <input type="email" className="form-control" id="email" value={this.state.userCopy.email} onChange={(e) => {this.handleFieldChange('email', e);}}/>
                </div>
                <div className="form-group">
                  <label htmlFor="password">Kodeord</label>
                  <input type="password" className="form-control" id="password" placeholder="****" value={this.state.password} onChange={this.handlePasswordChange} />
                </div>
                <div className="form-group">
                  <label htmlFor="password">Gentag kodeord</label>
                  <input type="password" className="form-control" id="passwordRepeat" placeholder="****" value={this.state.passwordRepeat} onChange={this.handlePasswordRepeatChange} />
                </div>
                {this.state.password && this.state.password === this.state.passwordRepeat && (
                  <div className="form-group">
                    <input type="submit" className="btn btn-primary" value="Skift adgangskode" onClick={this.handleClickChangePassword} />
                  </div>
                )}
                <div className="form-group">
                  <label htmlFor="phone">Telefonnummer</label>
                  <input type="text" className="form-control" id="phone" value={this.state.userCopy.phone} onChange={(e) => {this.handleFieldChange('phone', e);}} />
                </div>
                <WaitForState state={this.state} keys={['allRoles']}>
                  {this.state.allRoles && (
                    <div className="form-group">
                      <label>Roller</label>
                      {Object.values(this.state.allRoles).map((role) => { return (
                        <div className="form-check" key={role.id}>
                          <input className="form-check-input" type="checkbox" value={role.id} checked={this.hasRole(role)} id={"role-" + role.id} onChange={(e) => {this.handleRoleChange(role.id, e)}} disabled={this.state.assignAllowed[role.name] ? '' : 'disabled'} />
                          <label className="form-check-label" htmlFor={"role-" + role.id}>
                            {this.getReadableRole(role.name)}
                          </label>
                        </div>
                      )})}
                    </div>
                  )}
                </WaitForState>
                <div className="form-group">
                  <label htmlFor="status">Status</label>
                  <select className="form-control" id="status" value={this.state.userCopy.active} onChange={(e) => {this.handleFieldChange('status', e);}}>
                    <option value={1}>Aktiveret</option>
                    <option value={0}>Deaktiveret</option>
                  </select>
                </div>
              </div>
            )}
          </WaitForState>
        </div>
      </div>
    );
  }
}

export default withRouter(withUser(connect()(Users)));



// WEBPACK FOOTER //
// ./src/components/Profile/index.js